import { render, staticRenderFns } from "./itemRelay.vue?vue&type=template&id=697174fe&"
import script from "./itemRelay.vue?vue&type=script&lang=js&"
export * from "./itemRelay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports